import React from "react";
import NavBar from "../../components/navbar/NavBar";
import Footer from "../../components/footer/Footer";
import "./front-PageStyle.css"; // Import your CSS file
import { Link } from "react-router-dom";

const FrontPage = () => {
  return (
    <div>
      <NavBar />

      <div className="front-page-container">
        <h1 className="front-page-title">你想去哪里跑步？</h1>
        <div className="front-page-Routes">
          <Link to="/china">
            <img
              src={require("../../assets/pictures/RoutePicture/chinaRoute.png")}
              alt="China"
            />
          </Link>

          <Link to="/world">
            <img
              src={require("../../assets/pictures/RoutePicture/worldRoute.png")}
              alt="World"
            />
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FrontPage;
